<template>
  <div class="welcome pb-2">
    <h1>Bienvenido,</h1>
    <p class="welcome_company">{{ name }}</p>
    <div v-if="isMaster == 1">
      <v-icon small color="primary" class="mb-1 mr-1">mdi-guy-fawkes-mask</v-icon>
      <span>Master</span>
    </div>
    <p>{{ company }}</p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Welcome",
  props: {
    name: {
      type: String,
      default: "No registrado"
    },
    company: {
      type: String,
      default: "No registrado"
    }
  },
  computed: {
    ...mapGetters(["isMaster"])
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
.welcome {
  h1 {
    font-family: "Roboto Condensed", sans-serif;
    line-height: 1;
    font-size: .9em;
    color: $color-text-grey;
    font-weight: normal;
  }
  p {
    margin-bottom: 0;
    font-family: "Roboto Condensed", sans-serif;
    font-size: .9em;
    line-height: normal;
    &.welcome_company {
      font-weight: bold;
      font-size: 1.3em;
      font-family: "Roboto", sans-serif;
    }
  }
}
</style>
